import { HStack, VStack, Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { IconMail, IconPdf } from '../icons'
import { TextBodyBold1, TextBodyBold2 } from '../common/Text'
import { vw } from '../../styles/theme'
import Image from '../common/Image'
import Link from '../common/Link'
import SVG from '../common/SVG'
import useLocalize from '../../hooks/useLocalize'

export type NavSPPressContactProps = BoxProps & {}

const NavSPPressContact: React.FC<NavSPPressContactProps> = ({ ...others }) => {
  const localize = useLocalize()
  return (
    <>
      <Box {...others}>
        <Box>
          <VStack spacing={vw(50)} mb={vw(150)}>
            <Box>
              <TextBodyBold1 localizeKey="nav__title__press_contact" color="text.200" />
            </Box>
            <Box>
              <TextBodyBold1 as="span" localizeKey="nav__body__press_contact_1" />
            </Box>
            <Box textAlign="center">
              <SVG svg={<IconMail />} w="15px" mr="0.5em" />
              <Link to={`mailto:${localize('nav__body__press_contact_2')}`}>
                <TextBodyBold1 localizeKey="nav__body__press_contact_2" />
              </Link>
            </Box>
            <Box textAlign="center">
              <SVG svg={<IconPdf />} w="15px" mr="0.5em" />
              <TextBodyBold1 localizeKey="nav__body__press_contact_3" />
            </Box>
          </VStack>
          <VStack>
            <TextBodyBold2 localizeKey="nav__title__credit" />
            <HStack spacing="20px">
              <Image src="/images/footer_supported-01.png" w={vw(200)} h={vw(170)} />
              <Image src="/images/footer_supported-02.png" w={vw(200)} h={vw(170)} />
            </HStack>
          </VStack>
        </Box>
      </Box>
    </>
  )
}

export default NavSPPressContact
